import { render, staticRenderFns } from "./performance-mentoring-recap.vue?vue&type=template&id=36c825d8"
import script from "./performance-mentoring-recap.vue?vue&type=script&lang=js"
export * from "./performance-mentoring-recap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports